import React, { Component } from 'react';
import { defineMessages, intlShape, injectIntl } from 'react-intl';

import NotFoundText from '../components/messages/NotFoundText';
import * as clientActions from '../actions/client';
import { META_TITLE_PREFIX } from '../constants';

const messages = defineMessages({
  notFound: {
    id: 'error.not-found.title',
    defaultMessage: 'Not found',
  },
});

class NotFound extends Component {
  static propTypes = {
    intl: intlShape,
  };

  static onDataFetch(store, params, location, intl) {
    const notFound = intl.formatMessage(messages.notFound);
    store.dispatch(
      clientActions.setHelmet({
        title: META_TITLE_PREFIX + notFound,
        description: notFound,
      })
    );
  }

  render() {
    const { intl } = this.props;
    const notFound = intl.formatMessage(messages.notFound);

    return (
      <div className="u-page-container" role="main">
        <h1>{notFound}</h1>
        <p>
          <NotFoundText />
        </p>
      </div>
    );
  }
}

export default injectIntl(NotFound);
